import type { Tenant } from "@core/schema/Tenant.js";

export function getBenefitsWebApps(tenant: Tenant): { title: string; bg: string }[] {
	return [
		{
			title: "Přizpůsobení vašim potřebám",
			bg: "bg-fstgrey-400",
		},
		{
			title: "Škálovatelnost webových aplikací",
			bg: "bg-fstgrey-500",
		},
		{
			title: "Vysoká úroveň zabezpečení",
			bg: "bg-fstgrey-600",
		},
		{
			title: "Integrace s dalším systémy",
			bg: "bg-fstgrey-700",
		},
		{
			title: "Odlišení se od konkurence",
			bg: "bg-fstgrey-800",
		},
		{
			title: "Vývoj pomocí moderních technologií",
			bg: "bg-fstgrey-900",
		},
	];
}
